var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Collection" },
    [
      _c("div", { staticClass: "Collection-content" }, [
        _c("div", { staticClass: "Collection-top" }, [
          _vm.supplierType == 0
            ? _c("h1", [_vm._v("公司收款账户")])
            : _vm.supplierType == 1
            ? _c("h1", [_vm._v("个人收款账户")])
            : _vm._e(),
          _c(
            "a",
            {
              staticStyle: {
                "padding-top": "3px",
                "text-decoration": "underline",
                "font-size": "12px",
              },
              on: {
                click: function ($event) {
                  _vm.collectionTypeShow = true
                },
              },
            },
            [_vm._v("收款条件维护")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "Collection-main" },
          [
            _vm.supplierType == 0
              ? _c(
                  "el-form",
                  { staticClass: "Form-style" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "Company-name",
                        attrs: { label: "纳税人类型" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择纳税人类型" },
                            model: {
                              value: _vm.dataForm.taxpayer,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "taxpayer", $$v)
                              },
                              expression: "dataForm.taxpayer",
                            },
                          },
                          _vm._l(_vm.taxpayerOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "Company-name",
                        attrs: { label: "公司税号" },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入公司税号" },
                          model: {
                            value: _vm.dataForm.duty,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "duty", $$v)
                            },
                            expression: "dataForm.duty",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "Company-name",
                        attrs: { label: "账户名称" },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入账户名称" },
                          model: {
                            value: _vm.dataForm.accName,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "accName", $$v)
                            },
                            expression: "dataForm.accName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "Company-name",
                        attrs: { label: "开户行" },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "点击输入开户行" },
                          model: {
                            value: _vm.dataForm.bankDeposit,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "bankDeposit", $$v)
                            },
                            expression: "dataForm.bankDeposit",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "Company-name", attrs: { label: "账号" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "点击输入账号" },
                          model: {
                            value: _vm.dataForm.cardNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "cardNo", $$v)
                            },
                            expression: "dataForm.cardNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "Company-name",
                        attrs: { label: "财务联系人姓名" },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "点击输入姓名" },
                          model: {
                            value: _vm.dataForm.financeName,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "financeName", $$v)
                            },
                            expression: "dataForm.financeName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "Company-name",
                        attrs: { label: "财务联系方式" },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "点击输入手机号码" },
                          model: {
                            value: _vm.dataForm.financePhone,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "financePhone", $$v)
                            },
                            expression: "dataForm.financePhone",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "Company-name",
                        attrs: { label: "收款条件" },
                      },
                      [
                        _vm.dataForm.collection === 3
                          ? _c("span", [_vm._v(_vm._s(_vm.dataForm.remark))])
                          : _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.collectionText[_vm.dataForm.collection]
                                )
                              ),
                            ]),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "Company-name Last-hang",
                        attrs: { label: "企业收款二维码" },
                      },
                      [
                        _c("wintac-upload", {
                          attrs: {
                            imgName: "企业收款二维码",
                            pid: _vm.dataForm.supplierId,
                            state: 1,
                            env: "user",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm.supplierType == 1
              ? _c(
                  "el-form",
                  { staticClass: "Form-style" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "Company-name",
                        attrs: { label: "账户名称" },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "点击输入账户名称" },
                          model: {
                            value: _vm.dataForm.accName,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "accName", $$v)
                            },
                            expression: "dataForm.accName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "Company-name",
                        attrs: { label: "开户行" },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "点击输入开户行" },
                          model: {
                            value: _vm.dataForm.bankDeposit,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "bankDeposit", $$v)
                            },
                            expression: "dataForm.bankDeposit",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "Company-name", attrs: { label: "账号" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "点击输入账号" },
                          model: {
                            value: _vm.dataForm.cardNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "cardNo", $$v)
                            },
                            expression: "dataForm.cardNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "Company-name Last-hang",
                        attrs: { label: "个人收款二维码" },
                      },
                      [
                        _c("wintac-upload", {
                          attrs: {
                            imgName: "个人收款二维码",
                            state: 1,
                            pid: _vm.dataForm.supplierId,
                            env: "user",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "productTypeDialog",
          attrs: {
            title: "提示",
            "custom-class": "customProduct",
            visible: _vm.collectionTypeShow,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.collectionTypeShow = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-top" }, [
            _c("span", [_vm._v("收款条件维护")]),
          ]),
          _c(
            "div",
            { staticClass: "product-checkBox" },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.dataForm.collection,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "collection", $$v)
                    },
                    expression: "dataForm.collection",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v("发送回确认时提供支付信息,支付全款"),
                  ]),
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v("使用日期前支付全款"),
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v("账期为使用日期后一个月"),
                  ]),
                  _c("el-radio", { attrs: { label: 3 } }, [_vm._v("其它")]),
                ],
                1
              ),
              _vm.dataForm.collection === 3
                ? _c("el-input", {
                    staticStyle: { width: "80%" },
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "点击此处输入付款政策",
                    },
                    model: {
                      value: _vm.dataForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "remark", $$v)
                      },
                      expression: "dataForm.remark",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.collectionTypeShow = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.collectionTypeShow = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }